import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { iRootState } from '../redux/store';
import useStyles from '../useStyles';
import { QuoteStatuses } from '../constants';

const QuoteStatus = function QuoteStatus(): React.ReactElement {
  const classes = useStyles();
  const status = useSelector((state: iRootState) => state.quote.status) || '';
  const updatedDate = useSelector(
    (state: iRootState) => state.quote.updatedDate
  );

  function getMessageId() {
    switch (status) {
      case QuoteStatuses.Accepted:
        return 'acceptedOn';
      case QuoteStatuses.ChangesRequested:
        return 'requestedChangesOn';
      default:
        return 'declinedOn';
    }
  }

  const messageId = getMessageId();
  const defaultMessage = `${status} on {updatedDate, date, short} {updatedDate,time,long}`;

  return (
    <Grid item>
      <Typography className={classes.statusStyle}>
        <FormattedMessage
          id={messageId}
          defaultMessage={defaultMessage}
          values={{ updatedDate }}
        />
      </Typography>
    </Grid>
  );
};

export default QuoteStatus;
